var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMma(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 223,
    height: 222,
    viewBox: "0 0 223 222",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M67.984 174.07C26.7646 149.883 6.16116 89.3889 13.029 71.2461C18.5182 56.7186 42.7937 61.1544 54.2484 65.1911C54.2484 22.8506 74.8518 10.7517 129.819 10.7517C184.749 10.7517 212.246 22.8395 212.246 83.3339C212.246 131.729 198.51 163.989 191.642 174.07M67.984 174.07H191.642H67.984ZM67.984 174.07V210.367H191.642V174.07H67.984Z",
    stroke: "white",
    strokeWidth: 16.39,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M54.248 65.2026C58.8224 69.2171 72.1069 77.2904 88.5871 77.2904H150.422",
    fill: "white",
    strokeWidth: 16.39,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M54.248 65.2026C54.248 107.532 74.8515 113.587 88.5871 113.587",
    stroke: "white",
    strokeWidth: 16.39,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMma);
export default __webpack_public_path__ + "static/media/mma.e07554210057224e1f226967507a5b39.svg";
export { ForwardRef as ReactComponent };